import './_jquery.js';
import './moment-with-locales.custom.js';
import GLightbox from '@node/glightbox/dist/js/glightbox.min.js';
import '@node/iban/iban.js';
import '@node/tai-password-strength/lib/password-strength.js';

// Add globals
window.GLightbox = GLightbox;

// Import local legacy jQuery plugin files
import './daterangepicker.js';
import './slideupdown.js';
